import type SharedCustomField from '@/types/serializers/SharedCustomField';

export type CustomFieldValue = string | number | string[] | undefined;

/**
 * カスタムフィールドの値が実質空かどうかを判定する
 */
export function isCustomFieldValueEmpty(
  field: SharedCustomField,
  value: CustomFieldValue
): boolean {
  if (value == null) return true;
  if (value === '') return true;
  if (Array.isArray(value)) return value.length === 0;

  if (field.field_type === 'multiple_select' && typeof value === 'string') {
    const parts = value.split(',').map((v) => v.trim());
    return parts.length === 0 || parts.every((v) => v === '');
  }

  return false;
}

/**
 * 必須フィールドがすべて埋まっているかを判定する
 */
export function areRequiredCustomFieldsFilled(
  fields: SharedCustomField[] | undefined,
  values: Record<string, CustomFieldValue>
): boolean {
  if (!fields || fields.length === 0) return true;

  const requiredFields = fields.filter((field) => field.is_required);
  if (requiredFields.length === 0) return true;
  return requiredFields.every((field) => !isCustomFieldValueEmpty(field, values[String(field.id)]));
}
